import clsx from 'clsx';
import { useFormik } from 'formik';
import { FC, useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from 'yup';
import { isNotEmpty, toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { convertArrToSelect, copyToClipboard, downloadFile, getDateTime, navigateToModal, stringToDate, dateDownloadFormat } from '../../../../../../jsFunctions';
import { ContentsListLoading } from '../components/loading/ContentsListLoading';
import { useListView } from '../core/ListViewProvider';
import { useQueryResponse } from '../core/QueryResponseProvider';
import { Content, initialContent } from '../core/_models';
import { createContent, updateContent, uploadAndUpdate } from '../core/_requests';
import { ContentBasicLifecycle } from './ContentBasicLifecycle';
import { ContentPrintHistory } from './ContentPrintHistory';

type Props = {
  isContentLoading: boolean
  content: Content
}

const editContentSchema = Yup.object().shape({
  // name: Yup.string()
  //   .min(3, 'Minimum 3 symbols')
  //   .max(50, 'Maximum 50 symbols')
  //   .required('Name is required')
})

interface DropdownOptions {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}

const dropdownOptions: readonly DropdownOptions[] = [
  { value: 'content', label: 'content', color: '#00B8D9', isFixed: true },
  { value: 'client', label: 'client', color: '#00B8D9', isFixed: true },
  { value: 'testing', label: 'testing', color: '#00B8D9', isFixed: true },
  { value: 'SAYCHEESE', label: 'SAYCHEESE', color: 'red', isDisabled: true },
];

// const downloadFile = (url: string, filename: string) => {
//   const link = document.createElement('a');
//   link.href = url;
//   link.download = filename;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };


const ContentEditModalForm: FC<Props> = ({ content, isContentLoading }) => {
  const { setItemIdForUpdate, setSessionIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()


  const [contentForEdit] = useState<Content>({
    ...content,
    avatar: content.avatar || initialContent.avatar,
    info: content.info || initialContent.info,
    name: content.name || initialContent.name,
    tags: content.tags ? convertArrToSelect(content.tags) : dropdownOptions
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')

  const [avatar, setAvatar] = useState<any>(contentForEdit.avatar);

  const [dimensions, setDimensions] = useState<string>("");
  const [size, setSize] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<'basic' | 'printFlow' | 'json'>('basic')
  const [visitedTabs, setVisitedTabs] = useState<Record<string, boolean>>({basic: true})

  const openTab = (tab: 'basic' | 'printFlow' | 'json') => {
    setActiveTab(tab)
    setVisitedTabs((prev) => ({...prev, [tab]: true}))
  }


  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ): Promise<any> => {
    // const { target } = event;
    // const img = new Image();

    const ImageName = event.target.value.split('\\')[2];
    const Image = event.target.value;
    console.log('Imageon Kevel: ', Image); // Image on Kevel
    console.log('ImageName on Kevel: ', ImageName); // ImageName on Kevel
    console.log('ImageLink on Kevel: ', event.target.value); // ImageLink on Kevel
    // console.log('event current Target files: ', event.target?.files?[0].path);

    if (event?.target?.files?.[0]!) {
      setAvatar({ display: URL.createObjectURL(event?.target?.files?.[0]), upload: event?.target?.files?.[0] });
    }
  };

  useEffect(() => {
    const image = new Image();
    image.src = contentForEdit.original;

    image.onload = () => {
      setDimensions(image.width + " by " + image.height);
      fetch(image.src)
        .then(response => response.headers.get('content-length'))
        .then(size => {
          if (size) {
            const sizeInMB: number = parseFloat((parseInt(size) / (1024 * 1024)).toFixed(2)); // Convert bytes to MB with 2 decimal places
            setSize(sizeInMB)
            // Here you can do whatever you need with the image size in KB, such as setting state or logging it
          } else {
            console.error("Error: Could not determine image size.");
          }
        })
        .catch(error => {
          console.error("Error fetching image size:", error);
        });
    };

    image.onerror = () => {
      console.error('Error loading image');
    };
  }, [contentForEdit.avatar]);

  useEffect(() => {
    const loadMediaDimensionsAndSize = (src: string, type: string) => {
      if (type === 'image') {
        const image = new Image();
        image.src = src;

        image.onload = () => {
          setDimensions(image.width + " by " + image.height);
          fetch(src)
            .then(response => response.headers.get('content-length'))
            .then(size => {
              if (size) {
                const sizeInMB = parseFloat((parseInt(size) / (1024 * 1024)).toFixed(2)); // Convert bytes to MB with 2 decimal places
                setSize(sizeInMB);
              } else {
                console.error("Error: Could not determine image size.");
              }
            })
            .catch(error => {
              console.error("Error fetching image size:", error);
            });
        };

        image.onerror = () => {
          console.error('Error loading image');
        };
      } else if (type === 'video') {
        const video = document.createElement('video');
        video.src = src;

        video.onloadedmetadata = () => {
          setDimensions(video.videoWidth + " by " + video.videoHeight);
          fetch(src)
            .then(response => response.headers.get('content-length'))
            .then(size => {
              if (size) {
                const sizeInMB = parseFloat((parseInt(size) / (1024 * 1024)).toFixed(2)); // Convert bytes to MB with 2 decimal places
                setSize(sizeInMB);
              } else {
                console.error("Error: Could not determine video size.");
              }
            })
            .catch(error => {
              console.error("Error fetching video size:", error);
            });
        };

        video.onerror = () => {
          console.error('Error loading video');
        };
      }
    };

    if (contentForEdit.video) {
      loadMediaDimensionsAndSize(contentForEdit.video, 'video');
    }
  }, [contentForEdit.video]);



  const formik = useFormik({
    initialValues: contentForEdit,
    validationSchema: editContentSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {

          await updateContent({ ...values, isLocked: content.isDooh !== values.isDooh ? true : false })

          if (avatar.upload && values.id) {
            uploadAndUpdate(values.id, avatar.upload, values.id)
          }
        } else {
          await createContent({ ...values, avatar: avatar.upload })
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_content_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_content_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_content_header'
          data-kt-scroll-wrappers='#kt_modal_add_content_scroll'
          data-kt-scroll-offset='300px'
        >
          <div className='content-modal-tabs mb-8'>
            <div
              className='d-inline-flex flex-wrap p-1 rounded bg-light border border-gray-200'
              role='tablist'
              aria-label='Content modal sections'
            >
              {(
                [
                  {id: 'basic' as const, label: 'Basic', icon: 'bi-info-circle', hint: 'Details'},
                  {
                    id: 'printFlow' as const,
                    label: 'Print Flow',
                    icon: 'bi-diagram-3',
                    hint: 'Troubleshoot',
                  },
                  {id: 'json' as const, label: 'JSON', icon: 'bi-braces', hint: 'Raw data'},
                ] as const
              ).map((tab) => {
                const isActive = activeTab === tab.id
                return (
                  <button
                    key={tab.id}
                    type='button'
                    role='tab'
                    aria-selected={isActive}
                    className={clsx(
                      'btn btn-sm d-inline-flex align-items-center gap-2 px-4 py-2 border-0',
                      isActive
                        ? 'btn-primary shadow-sm'
                        : 'btn-active-light text-gray-700 bg-transparent'
                    )}
                    onClick={() => openTab(tab.id)}
                  >
                    <i className={clsx('bi fs-5', tab.icon, isActive ? 'text-white' : 'text-gray-500')} />
                    <span className='d-flex flex-column align-items-start lh-sm text-start'>
                      <span className={clsx('fw-bold fs-7', isActive ? 'text-white' : 'text-gray-800')}>
                        {tab.label}
                      </span>
                      <span
                        className={clsx('fs-8 fw-semibold', isActive ? 'text-white opacity-75' : 'text-muted')}
                      >
                        {tab.hint}
                      </span>
                    </span>
                  </button>
                )
              })}
            </div>
          </div>

          <div className={clsx({'d-none': activeTab !== 'basic'})}>
            {/* Overview — vertical document */}
            <div className='card card-flush border border-gray-200 mb-6'>
              <div className='card-header border-0 pt-5 pb-0'>
                <div className='card-title flex-column align-items-start'>
                  <span className='fw-bold text-gray-800'>Overview</span>
                  <span className='text-muted fs-7 fw-semibold mt-1'>Media and core content facts</span>
                </div>
              </div>
              <div className='card-body pt-5'>
                <div className='mb-5 text-start'>
                  <div className='fw-bold text-gray-800 fs-7 mb-2'>Preview</div>
                  <div className='position-relative d-inline-block text-start'>
                    {contentForEdit.video ? (
                      <video
                        className='rounded'
                        src={contentForEdit.video}
                        controls
                        controlsList='nodownload'
                        style={{
                          width: 225,
                          height: 'auto',
                          objectFit: 'contain',
                          background: '#f5f8fa',
                        }}
                      />
                    ) : (
                      <img
                        className='rounded'
                        src={contentForEdit.avatar}
                        alt='Content preview'
                        style={{
                          width: 125,
                          height: 'auto',
                          objectFit: 'contain',
                          background: '#f5f8fa',
                        }}
                      />
                    )}
                    <button
                      type='button'
                      className='btn btn-icon btn-sm btn-bg-white btn-active-color-primary position-absolute top-0 end-0 m-2 shadow-sm'
                      title='Download'
                      onClick={() => {
                        if (contentForEdit.video) {
                          downloadFile(
                            contentForEdit.video,
                            dateDownloadFormat(contentForEdit.activations[0].data.startDate.seconds * 1000) +
                              '-' +
                              contentForEdit.activations[0].label +
                              '-' +
                              contentForEdit.templateType +
                              '-' +
                              contentForEdit.sessionNumber,
                            true
                          )
                        } else {
                          downloadFile(
                            contentForEdit.original,
                            dateDownloadFormat(contentForEdit.activations[0].data.startDate.seconds * 1000) +
                              '-' +
                              contentForEdit.activations[0].label +
                              '-' +
                              contentForEdit.templateType +
                              '-' +
                              contentForEdit.sessionNumber
                          )
                        }
                      }}
                    >
                      <i className='bi bi-download'></i>
                    </button>
                  </div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Content ID</div>
                  <div className='d-flex align-items-center gap-2 flex-wrap'>
                    <div className='text-gray-700 fs-6 fw-semibold text-break'>{formik.values.id || '—'}</div>
                    <button
                      className='btn btn-sm btn-light-primary py-1 px-3'
                      type='button'
                      disabled={formik.isSubmitting || isContentLoading || !formik.values.id}
                      onClick={() => copyToClipboard(formik.values.id)}
                    >
                      Copy
                    </button>
                  </div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>API</div>
                  <div className='text-gray-700 fs-6 fw-semibold text-break'>{formik.values.api || '—'}</div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Dimensions</div>
                  <div className='text-gray-700 fs-6 fw-semibold'>{dimensions || '—'}</div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Size</div>
                  <div className='text-gray-700 fs-6 fw-semibold'>{size ? `${size} MB` : '—'}</div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Created</div>
                  <div className='text-gray-700 fs-6 fw-semibold'>{formik.values.dateCreated || '—'}</div>
                </div>

                <div className='mb-5'>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Last modified</div>
                  <div className='text-gray-700 fs-6 fw-semibold'>{formik.values.updatedOn || '—'}</div>
                </div>

                <div>
                  <div className='fw-bold text-gray-800 fs-7 mb-1'>Prints</div>
                  <div className='text-gray-700 fs-6 fw-semibold'>{contentForEdit.prints ?? 0}</div>
                </div>
              </div>
            </div>

            {/* Consents — vertical document */}
            <div className='card card-flush border border-gray-200 mb-6'>
              <div className='card-header border-0 pt-5 pb-0'>
                <div className='card-title flex-column align-items-start'>
                  <span className='fw-bold text-gray-800'>Consents</span>
                  <span className='text-muted fs-7 fw-semibold mt-1'>Recorded values · not editable here</span>
                </div>
              </div>
              <div className='card-body pt-5'>
                <div className='mb-5'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <span className='fw-bold text-gray-800 fs-7'>Marketing consent</span>
                    <span
                      className={clsx(
                        'badge fs-7',
                        formik.values.consent ? 'badge-light-success' : 'badge-light-secondary'
                      )}
                    >
                      {formik.values.consent ? 'Granted' : 'Not granted'}
                    </span>
                  </div>
                  <div className='text-gray-700 fs-6 fw-semibold'>Captured at content creation</div>
                </div>

                <div className='separator separator-dashed mb-5'></div>

                <div>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <span className='fw-bold text-gray-800 fs-7'>DOOH consent</span>
                    <span
                      className={clsx(
                        'badge fs-7',
                        formik.values.isDooh ? 'badge-light-success' : 'badge-light-secondary'
                      )}
                    >
                      {formik.values.isDooh ? 'Granted' : 'Not granted'}
                    </span>
                  </div>
                  <div className='text-gray-700 fs-6 fw-semibold'>
                    {formik.values.dooh
                      ? 'Activation supports DOOH'
                      : 'DOOH not enabled on activation'}
                  </div>
                </div>
              </div>
            </div>

            {/* Linked — vertical document */}
            <div className='card card-flush border border-gray-200 mb-6'>
              <div className='card-header border-0 pt-5 pb-0'>
                <div className='card-title flex-column align-items-start'>
                  <span className='fw-bold text-gray-800'>Linked</span>
                  <span className='text-muted fs-7 fw-semibold mt-1'>
                    Activation, collection, creator, template, session
                  </span>
                </div>
              </div>
              <div className='card-body pt-5'>
                {contentForEdit.activations.length ? (
                  <>
                    <div className='mb-5'>
                      <div className='d-flex align-items-center justify-content-between mb-2'>
                        <span className='fw-bold text-gray-800 fs-7'>Activation</span>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary'
                          onClick={() => copyToClipboard(contentForEdit.activations[0].value)}
                        >
                          Copy
                        </button>
                      </div>
                      <a
                        href='#'
                        className='d-flex align-items-start gap-3 text-hover-primary'
                        onClick={(e) => {
                          e.preventDefault()
                          navigateToModal('event', contentForEdit.activations[0].id)
                        }}
                      >
                        <div className='symbol symbol-40px'>
                          <img
                            src={
                              contentForEdit.activations[0].avatar
                                ? contentForEdit.activations[0].avatar
                                : blankImg
                            }
                            alt=''
                          />
                        </div>
                        <div className='min-w-0'>
                          <div className='fw-semibold text-gray-700 fs-6'>{contentForEdit.activations[0].label}</div>
                          <div className='text-gray-700 fs-6 mt-1'>
                            {getDateTime(contentForEdit.activations[0].data.startDate.seconds * 1000)}
                          </div>
                          <div className='text-gray-700 fs-6 mt-1'>
                            DOOH:{' '}
                            {contentForEdit.activations[0].data.isDooh
                              ? contentForEdit.activations[0].data.dooh
                              : 'Disabled'}
                          </div>
                          <div className='text-gray-700 fs-6'>
                            SW:{' '}
                            {contentForEdit.activations[0].data.isMicrosite
                              ? contentForEdit.activations[0].data.microsite
                              : 'Disabled'}
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className='separator separator-dashed mb-5'></div>
                  </>
                ) : null}

                {contentForEdit.collections.length ? (
                  <>
                    <div className='mb-5'>
                      <div className='d-flex align-items-center justify-content-between mb-2'>
                        <span className='fw-bold text-gray-800 fs-7'>Collection</span>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary'
                          onClick={() => copyToClipboard(contentForEdit.collections[0].value)}
                        >
                          Copy
                        </button>
                      </div>
                      <div
                        className='d-flex align-items-start gap-3 cursor-pointer'
                        onClick={() => navigateToModal('campaign', contentForEdit.collections[0].id)}
                      >
                        <div className='symbol symbol-40px'>
                          <img
                            src={
                              contentForEdit.collections[0].avatar
                                ? contentForEdit.collections[0].avatar
                                : blankImg
                            }
                            alt=''
                          />
                        </div>
                        <div className='min-w-0'>
                          <div className='fw-semibold text-gray-700 fs-6'>{contentForEdit.collections[0].label}</div>
                          <div className='text-gray-700 fs-6 mt-1'>
                            {getDateTime(contentForEdit.collections[0].data.dateCreated.seconds * 1000)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='separator separator-dashed mb-5'></div>
                  </>
                ) : null}

                {contentForEdit.memoryMakers.length ? (
                  <>
                    <div className='mb-5'>
                      <div className='d-flex align-items-center justify-content-between mb-2'>
                        <span className='fw-bold text-gray-800 fs-7'>Memory maker</span>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary'
                          onClick={() => copyToClipboard(contentForEdit.memoryMakers[0].value)}
                        >
                          Copy
                        </button>
                      </div>
                      <div
                        className='d-flex align-items-start gap-3 cursor-pointer'
                        onClick={() => navigateToModal('user', contentForEdit.memoryMakers[0].id)}
                      >
                        <div className='symbol symbol-40px'>
                          <img
                            src={
                              contentForEdit.memoryMakers[0].avatar
                                ? contentForEdit.memoryMakers[0].avatar
                                : blankImg
                            }
                            alt=''
                          />
                        </div>
                        <div className='min-w-0'>
                          <div className='fw-semibold text-gray-700 fs-6'>{contentForEdit.memoryMakers[0].label}</div>
                          <div className='text-gray-700 fs-6 mt-1'>{contentForEdit.memoryMakers[0].data.email}</div>
                        </div>
                      </div>
                    </div>
                    <div className='separator separator-dashed mb-5'></div>
                  </>
                ) : null}

                {contentForEdit.templates.length ? (
                  <>
                    <div className='mb-5'>
                      <div className='d-flex align-items-center justify-content-between mb-2'>
                        <span className='fw-bold text-gray-800 fs-7'>Template</span>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary'
                          onClick={() => copyToClipboard(contentForEdit.templates[0].value)}
                        >
                          Copy
                        </button>
                      </div>
                      <div
                        className='d-flex align-items-start gap-3 cursor-pointer'
                        onClick={() => navigateToModal('template', contentForEdit.templates[0].id)}
                      >
                        <div className='symbol symbol-40px'>
                          <img
                            src={
                              contentForEdit.templates[0].avatar
                                ? contentForEdit.templates[0].avatar
                                : blankImg
                            }
                            alt=''
                          />
                        </div>
                        <div className='min-w-0'>
                          <div className='fw-semibold text-gray-700 fs-6'>{contentForEdit.templates[0].label}</div>
                          <div className='text-gray-700 fs-6 mt-1'>{contentForEdit.templates[0].data.type}</div>
                        </div>
                      </div>
                    </div>
                    <div className='separator separator-dashed mb-5'></div>
                  </>
                ) : null}

                <div>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <span className='fw-bold text-gray-800 fs-7'>Session</span>
                    <span className='badge badge-light'>{contentForEdit.sessionNumber}</span>
                  </div>
                  <a
                    href='#'
                    className='text-primary fw-semibold fs-7'
                    onClick={(e) => {
                      e.preventDefault()
                      setSessionIdForUpdate && setSessionIdForUpdate(contentForEdit.session)
                      setItemIdForUpdate(null)
                    }}
                  >
                    Open session details
                  </a>
                </div>
              </div>
            </div>

            {/* Reach */}
            <div className='card card-flush border border-gray-200 mb-6'>
              <div className='card-header border-0 pt-5 pb-0'>
                <div className='card-title flex-column align-items-start'>
                  <span className='fw-bold text-gray-800'>Reach</span>
                  <span className='text-muted fs-7 fw-semibold mt-1'>QR codes and email recipients</span>
                </div>
              </div>
              <div className='card-body pt-5'>
                <div className='mb-5'>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <span className='fw-bold text-gray-800 fs-7'>QR codes</span>
                    <span className='badge badge-light'>{contentForEdit.qrCodes?.length || 0}</span>
                  </div>
                  <div className='d-flex flex-wrap gap-2'>
                    {contentForEdit.qrCodes?.length ? (
                      contentForEdit.qrCodes.map((item, index) => (
                        <span key={index} className='badge badge-light-info fw-semibold'>
                          {item}
                        </span>
                      ))
                    ) : (
                      <span className='text-muted fs-7'>None</span>
                    )}
                  </div>
                </div>

                <div className='separator separator-dashed mb-5'></div>

                <div>
                  <div className='d-flex align-items-center justify-content-between mb-2'>
                    <span className='fw-bold text-gray-800 fs-7'>Mails</span>
                    <span className='badge badge-light'>{contentForEdit.emails?.length || 0}</span>
                  </div>
                  <div className='d-flex flex-wrap gap-2'>
                    {contentForEdit.emails?.length ? (
                      contentForEdit.emails.map((item, index) => (
                        <span key={index} className='badge badge-light-primary fw-semibold'>
                          {item}
                        </span>
                      ))
                    ) : (
                      <span className='text-muted fs-7'>None</span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <ContentBasicLifecycle content={contentForEdit} enabled={visitedTabs.basic !== false} />
          </div>

          <div className={clsx({'d-none': activeTab !== 'printFlow'})}>
            <ContentPrintHistory
              content={contentForEdit}
              mode='printFlow'
              enabled={Boolean(contentForEdit.id)}
              onOpenJson={() => openTab('json')}
            />
          </div>

          <div className={clsx({'d-none': activeTab !== 'json'})}>
            {visitedTabs.json && (
              <ContentPrintHistory
                content={contentForEdit}
                mode='json'
                enabled={Boolean(visitedTabs.json)}
              />
            )}
          </div>

        </div>
        {/* end::Scroll */}



        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='button'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-contents-modal-action='cancel'
            disabled={formik.isSubmitting || isContentLoading}
          >
            Close
          </button>

          {!formik.values.id && (
            <button
              type='submit'
              className='btn btn-primary'
              data-kt-contents-modal-action='submit'
              disabled={isContentLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
            >
              <span className='indicator-label'>Submit</span>
              {(formik.isSubmitting || isContentLoading) && (
                <span className='indicator-progress'>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          )}
        </div>
        {/* end::Actions */}
      </form >
      {(formik.isSubmitting || isContentLoading) && <ContentsListLoading />
      }
    </>
  )
}

export { ContentEditModalForm };
